import styled from '@emotion/styled';

export const ExtrasMainWrap = styled.div`
  max-width: 596px;
  margin: auto;
`;

export const ExtrasFormWrap = styled.div`
  max-width: 460px;
  margin: auto;
`;

export const ExtraItemsListWrap = styled.ul`
  margin: 0;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
  padding-bottom: 30px;
  width: 100%;
  max-width: 475px;
`;

export const ExtraItemsList = styled.li`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 12px;
  padding-bottom: 12px;
  padding-top: 12px;
  margin: 0px -8px;
  padding-left: 8px;
  padding-right: 8px;
  align-items: center;
  border-bottom: 1px solid rgb(225, 225, 225);
`;

export const ExtraItemsActionsWrap = styled.div`
  display: grid;
  grid-template-columns: 38px 20px 38px;
  grid-gap: 8px;
  align-items: center;
`;

export const ExtraButton = styled.button`
  background: transparent;
  border: 0px;
  padding: 0px;
  width: 38px;
  height: 38px;
  cursor: pointer;
`;
